import { useState } from "react";

import type { AdminProfile } from "@/core/types";
import { Button2 } from "@/ui2/atoms/Button";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";

import { BasicInfoForm } from "./BasicInfoForm";

type BasicInfoCardProps = {
  isReadOnly?: boolean;
  profileData: AdminProfile;
};

// CSE account has no option to edit profile info
// TODO: Adjust BasicInfoForm to reuse in Provider scope

export function BasicInfoCard({ isReadOnly, profileData }: BasicInfoCardProps) {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <DashboardCard2
      {...(!isReadOnly && {
        Actions: (
          <Button2 isDisabled onPress={() => setIsEditing(true)} size="sm" variant="link">
            Edit
          </Button2>
        ),
      })}
      title="Basic Information"
    >
      <BasicInfoForm
        isReadOnly={!isEditing}
        key={isEditing ? "edit" : "view"}
        onCancel={() => setIsEditing(false)}
        profileData={profileData}
      />
    </DashboardCard2>
  );
}
